<template>
  <svg
    aria-hidden="true"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      d="M6.89772 31.4343L7.00156 31.2637C9.69853 27.0416 11.1248 22.1522 11.1147 17.1632C11.1147 15.1529 11.9251 13.2249 13.3676 11.8034C14.8101 10.3819 16.7665 9.58331 18.8065 9.58331C20.8465 9.58331 22.803 10.3819 24.2455 11.8034C25.688 13.2249 26.4983 15.1529 26.4983 17.1632C26.4983 19.0904 26.3637 20.9892 26.108 22.8482M32.2864 30.6782C33.5267 26.3842 34.1901 21.8495 34.1901 17.1632C34.1907 14.5018 33.4804 11.8872 32.1304 9.58212C30.7805 7.27706 28.8385 5.36284 26.4998 4.03188C24.1611 2.70093 21.5081 2.00015 18.8074 2C16.1067 1.99985 13.4536 2.70033 11.1147 4.03103M1.5 25.4329C2.73069 22.9334 3.42295 20.127 3.42295 17.1632C3.42295 14.4022 4.1729 11.8137 5.4805 9.58331M18.8065 17.1632C16.3927 25.4329 14.8617 30.6782 13.5127 35.3L18.8065 17.1632ZM22.0352 35.8174C23.2221 33.4837 24.1827 31.0448 24.9042 28.5331L22.0352 35.8174Z"
      stroke="#663399"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <circle cx="29.1752" cy="29.6741" r="14.3247" fill="white"></circle>
    <path
      d="M38.9422 29.674C38.9422 30.9566 38.6896 32.2266 38.1988 33.4116C37.7079 34.5966 36.9885 35.6733 36.0816 36.5802C35.1746 37.4871 34.0979 38.2066 32.913 38.6974C31.728 39.1882 30.458 39.4409 29.1754 39.4409C27.8927 39.4409 26.6227 39.1882 25.4377 38.6974C24.2528 38.2066 23.1761 37.4871 22.2691 36.5802C21.3622 35.6733 20.6428 34.5966 20.1519 33.4116C19.6611 32.2266 19.4085 30.9566 19.4085 29.674C19.4085 27.0836 20.4375 24.5994 22.2691 22.7678C24.1008 20.9361 26.585 19.9071 29.1754 19.9071C31.7657 19.9071 34.2499 20.9361 36.0816 22.7678C37.9132 24.5994 38.9422 27.0836 38.9422 29.674Z"
      stroke="#63CC98"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M33.4077 27.1676L27.8569 32.7184L25.3338 30.1953"
      stroke="#63CC98"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
